var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _g, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _g2, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntro1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 642,
    height: 630,
    viewBox: "0 0 642 630",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 315,
    cy: 315,
    r: 315,
    fill: "url(#paint0_linear_323_1929)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M267 91H357C357 91 351.537 82.8335 342.195 86.9168C342.195 86.9168 340.441 78.343 334.404 78.193C332.752 78.0761 331.099 78.4189 329.646 79.1798C328.193 79.9407 327.003 81.0871 326.221 82.4798C326.221 82.4798 319.206 72.0842 308.493 74.3133C305.511 74.8627 302.783 76.2839 300.688 78.3794C298.593 80.4748 297.234 83.1404 296.801 86.0058C296.801 86.0058 280.805 78.193 267 91Z",
    fill: "#D0C19A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M211 183H301C301 183 295.544 174.353 286.184 178.671C286.184 178.671 284.429 169.604 278.388 169.445C276.734 169.327 275.082 169.692 273.63 170.496C272.177 171.3 270.985 172.509 270.198 173.979C270.198 173.979 263.189 162.974 252.468 165.331C249.499 165.921 246.785 167.423 244.7 169.632C242.614 171.84 241.26 174.646 240.824 177.662C240.824 177.662 224.838 169.445 211 183Z",
    fill: "#D0C19A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M121 143H211C211 143 205.603 134.834 196.193 138.917C196.193 138.917 194.439 130.343 188.402 130.193C186.75 130.078 185.1 130.422 183.649 131.183C182.198 131.944 181.01 133.089 180.228 134.48C180.228 134.48 173.212 124.084 162.498 126.313C159.516 126.863 156.788 128.284 154.692 130.379C152.597 132.475 151.238 135.14 150.805 138.006C150.805 138.006 134.829 130.193 121 143Z",
    fill: "#D0C19A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M407.155 247.758H353.877V340.302H407.155V247.758Z",
    fill: "#96B6CC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M397.47 247.758H353.877V340.302H397.47V247.758Z",
    fill: "#96B6CC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M407.783 247.758H352.728V249.266H407.783V247.758Z",
    fill: "#F5F7FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M407.783 244.732H352.728V246.24H407.783V244.732Z",
    fill: "#F5F7FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M406.628 246.243H353.877V247.751H406.628V246.243Z",
    fill: "#96B6CC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M366.197 253.208H358.012V260.493H366.197V253.208Z",
    fill: "#96B6CC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M366.198 253.208H358.734V260.493H366.198V253.208Z",
    fill: "#96B6CC"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M378.605 253.208H370.42V260.493H378.605V253.208Z",
    fill: "#96B6CC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M378.604 253.208H371.141V260.493H378.604V253.208Z",
    fill: "#96B6CC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M391.003 253.208H382.818V260.493H391.003V253.208Z",
    fill: "#96B6CC"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M390.998 253.208H383.535V260.493H390.998V253.208Z",
    fill: "#96B6CC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M366.197 263.939H358.012V271.224H366.197V263.939Z",
    fill: "#96B6CC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M366.198 263.939H358.734V271.224H366.198V263.939Z",
    fill: "#96B6CC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M378.605 263.939H370.42V271.224H378.605V263.939Z",
    fill: "#96B6CC"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M378.604 263.939H371.141V271.224H378.604V263.939Z",
    fill: "#96B6CC"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M391.003 263.939H382.818V271.224H391.003V263.939Z",
    fill: "#96B6CC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M390.998 263.939H383.535V271.224H390.998V263.939Z",
    fill: "#96B6CC"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M366.197 283.588H358.012V290.873H366.197V283.588Z",
    fill: "#96B6CC"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M366.198 283.588H358.734V290.873H366.198V283.588Z",
    fill: "#96B6CC"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M378.605 283.588H370.42V290.873H378.605V283.588Z",
    fill: "#96B6CC"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M378.604 283.588H371.141V290.873H378.604V283.588Z",
    fill: "#96B6CC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M391.003 283.588H382.818V290.873H391.003V283.588Z",
    fill: "#96B6CC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M390.998 283.588H383.535V290.873H390.998V283.588Z",
    fill: "#96B6CC"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M366.197 294.32H358.012V301.605H366.197V294.32Z",
    fill: "#96B6CC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M366.198 294.32H358.734V301.605H366.198V294.32Z",
    fill: "#96B6CC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M378.605 294.32H370.42V301.605H378.605V294.32Z",
    fill: "#96B6CC"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M378.604 294.32H371.141V301.605H378.604V294.32Z",
    fill: "#96B6CC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M391.003 294.32H382.818V301.605H391.003V294.32Z",
    fill: "#96B6CC"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M390.998 294.32H383.535V301.605H390.998V294.32Z",
    fill: "#96B6CC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M366.197 316.153H358.012V323.438H366.197V316.153Z",
    fill: "#96B6CC"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M366.198 316.153H358.734V323.438H366.198V316.153Z",
    fill: "#96B6CC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M378.605 316.153H370.42V323.438H378.605V316.153Z",
    fill: "#96B6CC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M378.604 316.153H371.141V323.438H378.604V316.153Z",
    fill: "#96B6CC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M391.003 316.153H382.818V323.438H391.003V316.153Z",
    fill: "#96B6CC"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M390.998 316.153H383.535V323.438H390.998V316.153Z",
    fill: "#96B6CC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M366.197 326.889H358.012V334.174H366.197V326.889Z",
    fill: "#96B6CC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M366.198 326.889H358.734V334.174H366.198V326.889Z",
    fill: "#96B6CC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M378.605 326.889H370.42V334.174H378.605V326.889Z",
    fill: "#96B6CC"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M378.604 326.889H371.141V334.174H378.604V326.889Z",
    fill: "#96B6CC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M391.003 326.889H382.818V334.174H391.003V326.889Z",
    fill: "#96B6CC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M390.998 326.889H383.535V334.174H390.998V326.889Z",
    fill: "#96B6CC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M407.155 276.344H353.877V277.02H407.155V276.344Z",
    fill: "#F5F7FB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M407.155 309.938H353.877V310.614H407.155V309.938Z",
    fill: "#F5F7FB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M344.875 275.464H308.023V355.276H344.875V275.464Z",
    fill: "#F5F7FB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M334.38 275.464H308.023V355.276H334.38V275.464Z",
    fill: "#96B6CC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 282.03H310.734V286.27H320.545V282.03Z",
    fill: "#96B6CC"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 282.03H311.395V286.27H320.552V282.03Z",
    fill: "#96B6CC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 282.03H322.092V286.27H331.903V282.03Z",
    fill: "#96B6CC"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 282.03H322.74V286.27H331.892V282.03Z",
    fill: "#96B6CC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 290.005H310.734V294.245H320.545V290.005Z",
    fill: "#96B6CC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 290.005H311.395V294.245H320.552V290.005Z",
    fill: "#96B6CC"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 290.005H322.092V294.245H331.903V290.005Z",
    fill: "#96B6CC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 290.005H322.74V294.245H331.892V290.005Z",
    fill: "#96B6CC"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 300.197H310.734V304.438H320.545V300.197Z",
    fill: "#96B6CC"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 300.197H311.395V304.438H320.552V300.197Z",
    fill: "#96B6CC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 300.198H322.092V304.438H331.903V300.198Z",
    fill: "#96B6CC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 300.197H322.74V304.438H331.892V300.197Z",
    fill: "#96B6CC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 306.056H310.734V310.297H320.545V306.056Z",
    fill: "#96B6CC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 306.056H311.395V310.297H320.552V306.056Z",
    fill: "#96B6CC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 306.056H322.092V310.297H331.903V306.056Z",
    fill: "#96B6CC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 306.056H322.74V310.297H331.892V306.056Z",
    fill: "#96B6CC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 315.677H310.734V319.917H320.545V315.677Z",
    fill: "#96B6CC"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 315.677H311.395V319.917H320.552V315.677Z",
    fill: "#96B6CC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 315.677H322.092V319.917H331.903V315.677Z",
    fill: "#96B6CC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 315.677H322.74V319.917H331.892V315.677Z",
    fill: "#96B6CC"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 321.54H310.734V325.781H320.545V321.54Z",
    fill: "#96B6CC"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 321.54H311.395V325.781H320.552V321.54Z",
    fill: "#96B6CC"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 321.54H322.092V325.781H331.903V321.54Z",
    fill: "#96B6CC"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 321.54H322.74V325.78H331.892V321.54Z",
    fill: "#96B6CC"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 332.012H310.734V336.252H320.545V332.012Z",
    fill: "#96B6CC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 332.012H311.395V336.252H320.552V332.012Z",
    fill: "#96B6CC"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 332.012H322.092V336.252H331.903V332.012Z",
    fill: "#96B6CC"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 332.012H322.74V336.252H331.892V332.012Z",
    fill: "#96B6CC"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M320.545 339.742H310.734V343.982H320.545V339.742Z",
    fill: "#96B6CC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M320.552 339.742H311.395V343.982H320.552V339.742Z",
    fill: "#96B6CC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M331.903 339.742H322.092V343.982H331.903V339.742Z",
    fill: "#96B6CC"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M331.892 339.742H322.74V343.982H331.892V339.742Z",
    fill: "#96B6CC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M344.875 296.855H308.023V297.586H344.875V296.855Z",
    fill: "black"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M344.875 312.617H308.023V313.349H344.875V312.617Z",
    fill: "black"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M344.875 328.525H308.023V329.251H344.875V328.525Z",
    fill: "black"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M344.875 273.103H306.291V275.649H344.875V273.103Z",
    fill: "#F5F7FB"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M344.883 273.103H336.064V275.649H344.883V273.103Z",
    fill: "black"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M472.447 233.895H429.174V333.992H472.447V233.895Z",
    fill: "#96B6CC"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M456.423 233.895H413.15V333.992H456.423V233.895Z",
    fill: "#96B6CC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 240.692H416.938V245.793H452.659V240.692Z",
    fill: "#96B6CC"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 240.692H418.316V245.792H452.651V240.692Z",
    fill: "#96B6CC"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 249.273H416.938V254.374H452.659V249.273Z",
    fill: "#96B6CC"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 249.273H418.316V254.374H452.651V249.273Z",
    fill: "#96B6CC"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 258.196H416.938V263.297H452.659V258.196Z",
    fill: "#96B6CC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 258.196H418.316V263.297H452.651V258.196Z",
    fill: "#96B6CC"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 267.118H416.938V272.219H452.659V267.118Z",
    fill: "#96B6CC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 267.118H418.316V272.219H452.651V267.118Z",
    fill: "#96B6CC"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 276.031H416.938V281.132H452.659V276.031Z",
    fill: "#96B6CC"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 276.031H418.316V281.132H452.651V276.031Z",
    fill: "#96B6CC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 284.955H416.938V290.056H452.659V284.955Z",
    fill: "#96B6CC"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 284.955H418.316V290.056H452.651V284.955Z",
    fill: "#96B6CC"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 294.781H416.938V299.882H452.659V294.781Z",
    fill: "#96B6CC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 294.781H418.316V299.882H452.651V294.781Z",
    fill: "#96B6CC"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 304.609H416.938V309.709H452.659V304.609Z",
    fill: "#96B6CC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 304.609H418.316V309.709H452.651V304.609Z",
    fill: "#96B6CC"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 314.445H416.938V319.546H452.659V314.445Z",
    fill: "#96B6CC"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 314.445H418.316V319.546H452.651V314.445Z",
    fill: "#96B6CC"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M452.659 324.272H416.938V329.373H452.659V324.272Z",
    fill: "#96B6CC"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M452.651 324.272H418.316V329.373H452.651V324.272Z",
    fill: "#96B6CC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M473.568 232.89H411.93V235.33H473.568V232.89Z",
    fill: "#F5F7FB"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M473.568 228.484H411.93V230.924H473.568V228.484Z",
    fill: "#F5F7FB"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M471.519 230.441H413.15V232.882H471.519V230.441Z",
    fill: "#96B6CC"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 240.692H460.385V245.793H472.443V240.692Z",
    fill: "#F5F7FB"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 249.081H460.385V254.181H472.443V249.081Z",
    fill: "#F5F7FB"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 257.479H460.385V262.58H472.443V257.479Z",
    fill: "#F5F7FB"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 267.114H460.385V272.214H472.443V267.114Z",
    fill: "#F5F7FB"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 276.031H460.385V281.132H472.443V276.031Z",
    fill: "#F5F7FB"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 284.955H460.385V290.056H472.443V284.955Z",
    fill: "#F5F7FB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 294.781H460.385V299.882H472.443V294.781Z",
    fill: "#F5F7FB"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 304.609H460.385V309.709H472.443V304.609Z",
    fill: "#F5F7FB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 314.44H460.385V319.541H472.443V314.44Z",
    fill: "#F5F7FB"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M472.443 324.272H460.385V329.373H472.443V324.272Z",
    fill: "#F5F7FB"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M570.391 310.674H566.92V315.507H570.391V310.674Z",
    fill: "#F5F7FB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M570.391 318.582H566.92V323.414H570.391V318.582Z",
    fill: "#F5F7FB"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M570.391 326.269H566.92V331.101H570.391V326.269Z",
    fill: "#F5F7FB"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M570.391 334.398H566.92V339.23H570.391V334.398Z",
    fill: "#F5F7FB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M570.391 342.301H566.92V347.133H570.391V342.301Z",
    fill: "#F5F7FB"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M570.392 305.826H533.879V355.251H570.392V305.826Z",
    fill: "#96B6CC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M564.231 305.826H533.889V355.251H564.231V305.826Z",
    fill: "#96B6CC"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M561.284 310.674H536.609V315.507H561.284V310.674Z",
    fill: "#96B6CC"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M561.284 318.582H536.609V323.414H561.284V318.582Z",
    fill: "#96B6CC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M561.284 326.49H536.609V331.323H561.284V326.49Z",
    fill: "#96B6CC"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M561.284 334.398H536.609V339.23H561.284V334.398Z",
    fill: "#96B6CC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M561.284 342.301H536.609V347.133H561.284V342.301Z",
    fill: "#96B6CC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M561.282 310.674H537.518V315.507H561.282V310.674Z",
    fill: "#96B6CC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M561.282 318.582H537.518V323.414H561.282V318.582Z",
    fill: "#96B6CC"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M561.282 326.49H537.518V331.323H561.282V326.49Z",
    fill: "#96B6CC"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M561.282 334.398H537.518V339.23H561.282V334.398Z",
    fill: "#96B6CC"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M561.282 342.301H537.518V347.133H561.282V342.301Z",
    fill: "#96B6CC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M423.929 264.218H361.769V372.186H423.929V264.218Z",
    fill: "#145079"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M412.631 264.218H361.769V372.186H412.631V264.218Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M424.663 264.218H360.432V265.977H424.663V264.218Z",
    fill: "#145079"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M424.663 260.687H360.432V262.452H424.663V260.687Z",
    fill: "#145079"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M423.314 262.457H361.769V264.216H423.314V262.457Z",
    fill: "#ECECFA"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 270.572H366.59V279.075H376.143V270.572Z",
    fill: "#145079"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.15 270.572H367.437V279.075H376.15V270.572Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 270.572H381.062V279.075H390.616V270.572Z",
    fill: "#145079"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.615 270.572H381.902V279.075H390.615V270.572Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M405.081 270.572H395.527V279.075H405.081V270.572Z",
    fill: "#145079"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.077 270.572H396.365V279.075H405.077V270.572Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 283.088H366.59V291.591H376.143V283.088Z",
    fill: "#145079"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.15 283.088H367.437V291.591H376.15V283.088Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 283.088H381.062V291.591H390.616V283.088Z",
    fill: "#145079"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.615 283.088H381.902V291.591H390.615V283.088Z",
    fill: "white"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M405.081 283.088H395.527V291.591H405.081V283.088Z",
    fill: "#145079"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.077 283.088H396.365V291.591H405.077V283.088Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 306.013H366.59V314.516H376.143V306.013Z",
    fill: "#145079"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.15 306.013H367.437V314.516H376.15V306.013Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 306.013H381.062V314.516H390.616V306.013Z",
    fill: "#145079"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.615 306.013H381.902V314.516H390.615V306.013Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M405.081 306.013H395.527V314.516H405.081V306.013Z",
    fill: "#145079"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.077 306.013H396.365V314.516H405.077V306.013Z",
    fill: "white"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 318.533H366.59V327.036H376.143V318.533Z",
    fill: "#145079"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.15 318.533H367.437V327.036H376.15V318.533Z",
    fill: "white"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 318.533H381.062V327.036H390.616V318.533Z",
    fill: "#145079"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.615 318.533H381.902V327.036H390.615V318.533Z",
    fill: "white"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M405.081 318.534H395.527V327.037H405.081V318.534Z",
    fill: "#145079"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.077 318.533H396.365V327.036H405.077V318.533Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 344.013H366.59V352.516H376.143V344.013Z",
    fill: "#145079"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.15 344.013H367.437V352.516H376.15V344.013Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 344.013H381.062V352.516H390.616V344.013Z",
    fill: "#145079"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.615 344.013H381.902V352.516H390.615V344.013Z",
    fill: "white"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M405.081 344.013H395.527V352.516H405.081V344.013Z",
    fill: "#145079"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.077 344.013H396.365V352.516H405.077V344.013Z",
    fill: "white"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M376.143 356.534H366.59V365.037H376.143V356.534Z",
    fill: "#145079"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M376.15 356.534H367.437V365.037H376.15V356.534Z",
    fill: "white"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 356.534H381.062V365.037H390.616V356.534Z",
    fill: "#145079"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M390.615 356.534H381.902V365.037H390.615V356.534Z",
    fill: "white"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M405.081 356.534H395.527V365.037H405.081V356.534Z",
    fill: "#145079"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M405.077 356.534H396.365V365.037H405.077V356.534Z",
    fill: "white"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M423.929 297.566H361.769V298.354H423.929V297.566Z",
    fill: "white"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M423.929 336.754H361.769V337.542H423.929V336.754Z",
    fill: "white"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M509.512 279.076H466.521V372.184H509.512V279.076Z",
    fill: "#145079"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M499.224 279.076H466.521V372.184H499.224V279.076Z",
    fill: "white"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 286.724H469.689V291.669H481.132V286.724Z",
    fill: "#145079"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 286.724H470.447V291.669H481.13V286.724Z",
    fill: "white"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 286.724H482.936V291.669H494.378V286.724Z",
    fill: "#145079"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 286.724H483.693V291.669H494.376V286.724Z",
    fill: "white"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 296.027H469.689V300.971H481.132V296.027Z",
    fill: "#145079"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 296.027H470.447V300.971H481.13V296.027Z",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 296.027H482.936V300.971H494.378V296.027Z",
    fill: "#145079"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 296.027H483.693V300.971H494.376V296.027Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 307.923H469.689V312.867H481.132V307.923Z",
    fill: "#145079"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 307.923H470.447V312.867H481.13V307.923Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 307.923H482.936V312.867H494.378V307.923Z",
    fill: "#145079"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 307.923H483.693V312.867H494.376V307.923Z",
    fill: "white"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 314.758H469.689V319.702H481.132V314.758Z",
    fill: "#145079"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 314.758H470.447V319.702H481.13V314.758Z",
    fill: "white"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 314.758H482.936V319.702H494.378V314.758Z",
    fill: "#145079"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 314.758H483.693V319.702H494.376V314.758Z",
    fill: "white"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 325.989H469.689V330.934H481.132V325.989Z",
    fill: "#145079"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 325.989H470.447V330.934H481.13V325.989Z",
    fill: "white"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 325.989H482.936V330.934H494.378V325.989Z",
    fill: "#145079"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 325.989H483.693V330.934H494.376V325.989Z",
    fill: "white"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 332.82H469.689V337.764H481.132V332.82Z",
    fill: "#145079"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 332.82H470.447V337.764H481.13V332.82Z",
    fill: "white"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 332.82H482.936V337.764H494.378V332.82Z",
    fill: "#145079"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 332.82H483.693V337.764H494.376V332.82Z",
    fill: "white"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 345.038H469.689V349.982H481.132V345.038Z",
    fill: "#145079"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 345.038H470.447V349.982H481.13V345.038Z",
    fill: "white"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 345.038H482.936V349.982H494.378V345.038Z",
    fill: "#145079"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 345.038H483.693V349.982H494.376V345.038Z",
    fill: "white"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M481.132 354.066H469.689V359.01H481.132V354.066Z",
    fill: "#145079"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M481.13 354.066H470.447V359.01H481.13V354.066Z",
    fill: "white"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M494.378 354.066H482.936V359.01H494.378V354.066Z",
    fill: "#145079"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M494.376 354.066H483.693V359.01H494.376V354.066Z",
    fill: "white"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M509.522 276.32H464.504V279.291H509.522V276.32Z",
    fill: "#145079"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M509.518 276.32H499.23V279.291H509.518V276.32Z",
    fill: "black"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M466.525 320.188H462.477V325.825H466.525V320.188Z",
    fill: "#F5F7FB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M466.525 329.414H462.477V335.051H466.525V329.414Z",
    fill: "#F5F7FB"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M466.525 338.375H462.477V344.012H466.525V338.375Z",
    fill: "#F5F7FB"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M466.525 347.856H462.477V353.493H466.525V347.856Z",
    fill: "#F5F7FB"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M466.525 357.082H462.477V362.719H466.525V357.082Z",
    fill: "#F5F7FB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M466.521 314.522H423.926V372.182H466.521V314.522Z",
    fill: "#145079"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M459.327 314.517H423.926V372.183H459.327V314.517Z",
    fill: "white"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 320.188H427.104V325.825H455.889V320.188Z",
    fill: "#145079"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 329.414H427.104V335.051H455.889V329.414Z",
    fill: "#145079"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 338.635H427.104V344.272H455.889V338.635Z",
    fill: "#145079"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 347.856H427.104V353.493H455.889V347.856Z",
    fill: "#145079"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M455.889 357.082H427.104V362.719H455.889V357.082Z",
    fill: "#145079"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M455.897 320.184H428.172V325.821H455.897V320.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M455.897 329.409H428.172V335.046H455.897V329.409Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M455.897 338.631H428.172V344.268H455.897V338.631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M455.897 347.856H428.172V353.493H455.897V347.856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M455.897 357.077H428.172V362.714H455.897V357.077Z",
    fill: "white"
  }))), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M336.227 332.233H307.648V372.183H353.256V332.233V314.517L336.227 332.233Z",
    fill: "#145079"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M361.769 314.517H353.258V372.183H361.769V314.517Z",
    fill: "#145079"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M361.769 314.517H353.258V372.183H361.769V314.517Z",
    fill: "white"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M423.924 265.969H412.619V372.178H423.924V265.969Z",
    fill: "white"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M466.521 314.517H459.328V372.183H466.521V314.517Z",
    fill: "white"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M509.518 279.293H499.23V372.183H509.518V279.293Z",
    fill: "white"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 263.328H513.916V269.278H515.534V263.328Z",
    fill: "white"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 273.343H513.916V279.292H515.534V273.343Z",
    fill: "white"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 283.747H513.916V289.697H515.534V283.747Z",
    fill: "white"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 294.156H513.916V300.106H515.534V294.156Z",
    fill: "white"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 304.56H513.916V310.51H515.534V304.56Z",
    fill: "white"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 314.97H513.916V320.92H515.534V314.97Z",
    fill: "white"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 326.442H513.916V332.391H515.534V326.442Z",
    fill: "white"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 337.904H513.916V343.854H515.534V337.904Z",
    fill: "white"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 349.371H513.916V355.321H515.534V349.371Z",
    fill: "white"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M515.534 360.839H513.916V366.789H515.534V360.839Z",
    fill: "white"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M578.692 255.401H528.207V372.18H578.692V255.401Z",
    fill: "#145079"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M559.997 255.401H509.512V372.18H559.997V255.401Z",
    fill: "#145079"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M578.688 257.084H560.002V372.187H578.688V257.084Z",
    fill: "white"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 263.328H564.623V269.278H578.69V263.328Z",
    fill: "#145079"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 273.121H564.623V279.071H578.69V273.121Z",
    fill: "#145079"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 282.91H564.623V288.86H578.69V282.91Z",
    fill: "#145079"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 294.151H564.623V300.101H578.69V294.151Z",
    fill: "#145079"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 304.56H564.623V310.51H578.69V304.56Z",
    fill: "#145079"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 314.97H564.623V320.92H578.69V314.97Z",
    fill: "#145079"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 326.432H564.623V332.382H578.69V326.432Z",
    fill: "#145079"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 337.9H564.623V343.849H578.69V337.9Z",
    fill: "#145079"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 349.371H564.623V355.321H578.69V349.371Z",
    fill: "#145079"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M578.69 360.839H564.623V366.789H578.69V360.839Z",
    fill: "#145079"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 263.328H564.623V269.278H578.69V263.328Z",
    fill: "white"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 273.121H564.623V279.071H578.69V273.121Z",
    fill: "white"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 282.91H564.623V288.86H578.69V282.91Z",
    fill: "white"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 294.151H564.623V300.101H578.69V294.151Z",
    fill: "white"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 304.56H564.623V310.51H578.69V304.56Z",
    fill: "white"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 314.97H564.623V320.92H578.69V314.97Z",
    fill: "white"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 326.432H564.623V332.382H578.69V326.432Z",
    fill: "white"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 337.9H564.623V343.849H578.69V337.9Z",
    fill: "white"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 349.371H564.623V355.321H578.69V349.371Z",
    fill: "white"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M578.69 360.839H564.623V366.789H578.69V360.839Z",
    fill: "white"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M559.997 255.401H509.512V372.18H559.997V255.401Z",
    fill: "white"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 263.328H513.916V269.278H555.594V263.328Z",
    fill: "#145079"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 263.328H515.533V269.278H555.592V263.328Z",
    fill: "white"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 273.343H513.916V279.292H555.594V273.343Z",
    fill: "#145079"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 273.343H515.533V279.293H555.592V273.343Z",
    fill: "white"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 283.747H513.916V289.697H555.594V283.747Z",
    fill: "#145079"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 283.747H515.533V289.697H555.592V283.747Z",
    fill: "white"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 294.156H513.916V300.106H555.594V294.156Z",
    fill: "#145079"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 294.156H515.533V300.106H555.592V294.156Z",
    fill: "white"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 304.56H513.916V310.51H555.594V304.56Z",
    fill: "#145079"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 304.56H515.533V310.51H555.592V304.56Z",
    fill: "white"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 314.97H513.916V320.92H555.594V314.97Z",
    fill: "#145079"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 314.97H515.533V320.92H555.592V314.97Z",
    fill: "white"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 326.442H513.916V332.391H555.594V326.442Z",
    fill: "#145079"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 326.441H515.533V332.391H555.592V326.441Z",
    fill: "white"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 337.904H513.916V343.854H555.594V337.904Z",
    fill: "#145079"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 337.904H515.533V343.854H555.592V337.904Z",
    fill: "white"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 349.371H513.916V355.321H555.594V349.371Z",
    fill: "#145079"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 349.371H515.533V355.321H555.592V349.371Z",
    fill: "white"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M555.594 360.839H513.916V366.789H555.594V360.839Z",
    fill: "#145079"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M555.592 360.839H515.533V366.789H555.592V360.839Z",
    fill: "white"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M577.609 251.933H560.002V254.223H577.609V251.933Z",
    fill: "#145079"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M577.609 251.375H509.512V254.223H577.609V251.375Z",
    fill: "#ECECFA"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M580 254.227H508.086V257.076H580V254.227Z",
    fill: "#145079"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M580 249.085H508.086V251.933H580V249.085Z",
    fill: "#145079"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M580 254.227H508.086V257.076H580V254.227Z",
    fill: "black"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M580 249.085H508.086V251.933H580V249.085Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M509.512 303.886H466.521V304.735H509.512V303.886Z",
    fill: "white"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M509.512 322.281H466.521V323.13H509.512V322.281Z",
    fill: "white"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M509.512 340.838H466.521V341.687H509.512V340.838Z",
    fill: "white"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M424.652 264.218H412.619V265.977H424.652V264.218Z",
    fill: "black"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M424.652 260.687H412.619V262.446H424.652V260.687Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M580 254.227H560.002V257.076H580V254.227Z",
    fill: "black"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M580 249.085H560.002V251.933H580V249.085Z",
    fill: "black"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M336.227 332.233H307.648V372.183H353.256V332.233V314.517L336.227 332.233Z",
    fill: "white"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M318.572 340.333H311.787V346.372H318.572V340.333Z",
    fill: "#145079"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M332.373 340.333H325.588V346.372H332.373V340.333Z",
    fill: "#145079"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M346.184 340.333H339.398V346.372H346.184V340.333Z",
    fill: "#145079"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M318.572 350.492H311.787V356.531H318.572V350.492Z",
    fill: "#145079"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M332.373 350.492H325.588V356.531H332.373V350.492Z",
    fill: "#145079"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M346.184 350.492H339.398V356.531H346.184V350.492Z",
    fill: "#145079"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M318.572 360.656H311.787V366.695H318.572V360.656Z",
    fill: "#145079"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M332.373 360.656H325.588V366.695H332.373V360.656Z",
    fill: "#145079"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M346.184 360.656H339.398V366.695H346.184V360.656Z",
    fill: "#145079"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.315 340.333H312.529V346.372H319.315V340.333Z",
    fill: "white"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M333.123 340.333H326.338V346.372H333.123V340.333Z",
    fill: "white"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.93 340.333H340.145V346.372H346.93V340.333Z",
    fill: "white"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.315 350.492H312.529V356.531H319.315V350.492Z",
    fill: "white"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M333.123 350.492H326.338V356.531H333.123V350.492Z",
    fill: "white"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.93 350.492H340.145V356.531H346.93V350.492Z",
    fill: "white"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M319.315 360.656H312.529V366.695H319.315V360.656Z",
    fill: "white"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M333.123 360.656H326.338V366.695H333.123V360.656Z",
    fill: "white"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M346.93 360.656H340.145V366.695H346.93V360.656Z",
    fill: "white"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M432.152 376.808L428.223 394.552H441.41L440.073 376.808H432.152Z",
    fill: "#145079"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M444.478 376.808L450.128 394.552H458.965L451.722 376.808H444.478Z",
    fill: "#145079"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M456.695 376.808L468.32 394.552H478.35L463.242 376.808H456.695Z",
    fill: "#145079"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M468.486 376.808L487.75 394.552H499.745L475.673 376.808H468.486Z",
    fill: "#145079"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M427.223 376.808L421.574 394.552H412.736L419.98 376.808H427.223Z",
    fill: "#145079"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M415.009 376.808L403.384 394.552H393.353L408.462 376.808H415.009Z",
    fill: "#145079"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M403.218 376.808L383.954 394.552H371.959L396.031 376.808H403.218Z",
    fill: "#145079"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M432.152 376.808L428.223 394.552H441.41L440.073 376.808H432.152Z",
    fill: "white"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M444.478 376.808L450.128 394.552H458.965L451.722 376.808H444.478Z",
    fill: "white"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M456.695 376.808L468.32 394.552H478.35L463.242 376.808H456.695Z",
    fill: "white"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M468.486 376.808L487.75 394.552H499.745L475.673 376.808H468.486Z",
    fill: "white"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M427.223 376.808L421.574 394.552H412.736L419.98 376.808H427.223Z",
    fill: "white"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M415.009 376.808L403.384 394.552H393.353L408.462 376.808H415.009Z",
    fill: "white"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M403.218 376.808L383.954 394.552H371.959L396.031 376.808H403.218Z",
    fill: "white"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M342.113 370.124C344.423 370.051 346.69 369.551 348.771 368.654C350.851 367.758 352.698 366.485 354.195 364.917C355.692 363.35 356.805 361.522 357.463 359.55C358.121 357.578 358.311 355.505 358.019 353.465C357.604 350.554 356.236 347.833 355.269 345.029C353.443 339.727 352.859 333.744 348.666 329.637C347.372 328.374 345.796 327.366 344.039 326.675C342.283 325.985 340.383 325.629 338.463 325.629C336.543 325.629 334.643 325.985 332.887 326.675C331.13 327.366 329.554 328.374 328.26 329.637C325.542 332.291 324.255 335.878 323.697 339.436C323.138 342.995 323.213 346.599 322.868 350.157C322.554 353.124 321.92 356.085 322.058 359.063C322.197 362.04 323.201 365.141 325.655 367.169C326.908 368.12 328.307 368.906 329.81 369.504C331.257 370.221 332.826 370.723 334.455 370.99C335.272 371.119 336.11 371.083 336.908 370.885C337.707 370.686 338.445 370.331 339.069 369.845C340.063 370.069 341.088 370.164 342.113 370.124V370.124Z",
    fill: "#145079"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M342.113 370.124C344.423 370.051 346.69 369.551 348.771 368.654C350.851 367.758 352.698 366.485 354.195 364.917C355.692 363.35 356.805 361.522 357.463 359.55C358.121 357.578 358.311 355.505 358.019 353.465C357.604 350.554 356.236 347.833 355.269 345.029C353.443 339.727 352.859 333.744 348.666 329.637C347.372 328.374 345.796 327.366 344.039 326.675C342.283 325.985 340.383 325.629 338.463 325.629C336.543 325.629 334.643 325.985 332.887 326.675C331.13 327.366 329.554 328.374 328.26 329.637C325.542 332.291 324.255 335.878 323.697 339.436C323.138 342.995 323.213 346.599 322.868 350.157C322.554 353.124 321.92 356.085 322.058 359.063C322.197 362.04 323.201 365.141 325.655 367.169C326.908 368.12 328.307 368.906 329.81 369.504C331.257 370.221 332.826 370.723 334.455 370.99C335.272 371.119 336.11 371.083 336.908 370.885C337.707 370.686 338.445 370.331 339.069 369.845C340.063 370.069 341.088 370.164 342.113 370.124V370.124Z",
    fill: "white"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M334.432 380.958V380.215L335.819 379.17C335.819 379.17 337.476 364.086 337.758 359.717C338.041 355.348 338.386 348.465 336.578 343.471C338.18 346.876 339.32 350.44 339.974 354.086C339.974 354.086 342.121 347.214 345.931 342.839C345.931 342.839 341.286 353.398 341.914 363.22C342.227 368.801 343.013 374.353 344.267 379.829L345.096 380.321L345.165 380.941L334.432 380.958Z",
    fill: "#145079"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M338.679 356.725C338.679 356.725 337.474 351.965 334.228 349.607C334.228 349.607 336.946 352.959 337.838 358.591C338.729 364.222 339.677 360.647 339.677 360.647L338.679 356.725Z",
    fill: "#145079"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M337.251 369.597C336.864 368.429 336 367.432 334.828 366.803C334.828 366.803 336.083 367.876 336.661 371.312C337.238 374.748 338.682 372.854 338.682 372.854L338.795 370.96L337.251 369.597Z",
    fill: "#145079"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M336.678 371.308C336.05 367.872 334.845 366.799 334.845 366.799C335.738 367.29 336.459 367.992 336.929 368.827C337.306 365.168 337.657 361.52 337.776 359.715C337.776 359.358 337.82 358.978 337.839 358.598C336.948 352.944 334.236 349.614 334.236 349.614C336.119 350.983 337.318 353.168 338.002 354.754C338.059 351.034 337.814 346.832 336.609 343.48C338.21 346.886 339.35 350.449 340.005 354.095C340.005 354.095 342.151 347.223 345.961 342.849C345.961 342.849 341.317 353.408 341.944 363.229C342.257 368.811 343.044 374.363 344.298 379.839L345.127 380.33L345.196 380.95H334.437V380.207L335.824 379.163C335.824 379.163 336.22 375.526 336.678 371.308Z",
    fill: "black"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M527.004 372.517C524.396 372.433 521.837 371.867 519.489 370.855C517.14 369.842 515.055 368.405 513.365 366.635C511.676 364.866 510.419 362.802 509.675 360.576C508.932 358.35 508.717 356.01 509.046 353.706C509.517 350.421 511.061 347.348 512.153 344.209C514.218 338.22 514.877 331.465 519.61 326.834C521.069 325.407 522.848 324.268 524.83 323.488C526.813 322.708 528.957 322.305 531.125 322.305C533.293 322.305 535.437 322.708 537.419 323.488C539.402 324.268 541.18 325.407 542.64 326.834C545.709 329.823 547.165 333.879 547.799 337.89C548.433 341.901 548.333 345.974 548.753 350.013C549.105 353.365 549.82 356.717 549.67 360.069C549.519 363.421 548.377 366.93 545.609 369.226C544.185 370.303 542.596 371.193 540.889 371.868C539.254 372.678 537.481 373.245 535.641 373.544C534.719 373.69 533.772 373.649 532.87 373.425C531.968 373.201 531.135 372.799 530.431 372.248C529.31 372.486 528.155 372.576 527.004 372.517V372.517Z",
    fill: "#145079"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M527.004 372.517C524.396 372.433 521.837 371.867 519.489 370.855C517.14 369.842 515.055 368.405 513.365 366.635C511.676 364.866 510.419 362.802 509.675 360.576C508.932 358.35 508.717 356.01 509.046 353.706C509.517 350.421 511.061 347.348 512.153 344.209C514.218 338.22 514.877 331.465 519.61 326.834C521.069 325.407 522.848 324.268 524.83 323.488C526.813 322.708 528.957 322.305 531.125 322.305C533.293 322.305 535.437 322.708 537.419 323.488C539.402 324.268 541.18 325.407 542.64 326.834C545.709 329.823 547.165 333.879 547.799 337.89C548.433 341.901 548.333 345.974 548.753 350.013C549.105 353.365 549.82 356.717 549.67 360.069C549.519 363.421 548.377 366.93 545.609 369.226C544.185 370.303 542.596 371.193 540.889 371.868C539.254 372.678 537.481 373.245 535.641 373.544C534.719 373.69 533.772 373.649 532.87 373.425C531.968 373.201 531.135 372.799 530.431 372.248C529.31 372.486 528.155 372.576 527.004 372.517V372.517Z",
    fill: "white"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M535.65 384.741V383.908L534.087 382.724C534.087 382.724 532.204 365.679 531.896 360.768C531.588 355.858 531.193 348.064 533.227 342.427C531.42 346.275 530.136 350.302 529.404 354.422C529.404 354.422 526.981 346.667 522.682 341.723C522.682 341.723 527.923 353.645 527.22 364.735C526.861 371.031 525.972 377.295 524.558 383.473L523.623 384.031L523.542 384.724L535.65 384.741Z",
    fill: "#145079"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M530.882 357.387C530.882 357.387 532.238 352.012 535.904 349.348C535.904 349.348 532.834 353.107 531.83 359.493C530.826 365.879 529.746 361.806 529.746 361.806L530.882 357.387Z",
    fill: "#145079"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M532.516 371.923C532.951 370.601 533.927 369.473 535.253 368.761C535.253 368.761 533.853 369.973 533.188 373.851C532.522 377.728 530.897 375.571 530.897 375.571L530.777 373.437L532.516 371.923Z",
    fill: "#145079"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M533.139 373.852C533.804 369.975 535.204 368.763 535.204 368.763C534.191 369.314 533.373 370.108 532.844 371.053C532.423 366.925 532.028 362.802 531.896 360.768C531.896 360.361 531.846 359.93 531.821 359.489C532.825 353.109 535.894 349.349 535.894 349.349C533.76 350.897 532.411 353.36 531.651 355.154C531.588 350.953 531.865 346.215 533.227 342.427C531.42 346.275 530.136 350.302 529.404 354.422C529.404 354.422 526.981 346.668 522.682 341.723C522.682 341.723 527.923 353.645 527.22 364.735C526.861 371.031 525.972 377.295 524.558 383.473L523.623 384.031L523.542 384.724H535.65V383.892L534.087 382.707C534.087 382.707 533.647 378.618 533.139 373.852Z",
    fill: "black"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M287.592 242.972C314.231 237.261 331.326 254.067 339.033 309.071C346.74 364.075 385.211 393.423 405.423 416.676",
    stroke: "#0144B9"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M319.367 461.69H364.381",
    stroke: "#FFC844",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M372.324 461.69H465",
    stroke: "#FFC844",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M12 372L642 372",
    stroke: "#FFC844",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M344.521 457.719H381.592",
    stroke: "#FFC844",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M416.014 444.253C416.014 444.253 417.216 446.029 424.03 446.384C430.843 446.739 430.843 452.423 434.851 452.423C438.859 452.423 436.855 449.226 435.252 447.805C433.649 446.384 430.443 443.898 430.443 443.898C430.443 443.898 425.232 442.832 423.629 441.056C422.026 439.28 417.617 437.859 417.617 437.859L416.014 444.253Z",
    fill: "#FB8F8F"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M416.014 444.253C416.014 444.253 417.216 446.029 424.03 446.384C430.843 446.739 430.843 452.423 434.851 452.423C438.859 452.423 436.855 449.226 435.252 447.805C433.649 446.384 430.443 443.898 430.443 443.898C430.443 443.898 425.232 442.832 423.629 441.056C422.026 439.28 417.617 437.859 417.617 437.859L416.014 444.253Z",
    fill: "url(#paint1_radial_323_1929)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M416.014 444.253C416.014 444.253 417.216 446.029 424.03 446.384C430.843 446.739 430.843 452.423 434.851 452.423C438.859 452.423 436.855 449.226 435.252 447.805C433.649 446.384 430.443 443.898 430.443 443.898C430.443 443.898 425.232 442.832 423.629 441.056C422.026 439.28 417.617 437.859 417.617 437.859L416.014 444.253Z",
    fill: "#A9A9BF"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M373.54 437.19C373.54 437.19 371.921 441.093 368.28 444.995C368.28 444.995 366.257 446.06 369.494 447.833C372.731 449.607 377.181 451.381 377.586 454.574C377.586 454.574 377.991 455.993 375.967 456.348C373.944 456.702 370.707 454.929 370.707 454.929C370.707 454.929 367.471 452.09 364.234 450.671C360.997 449.252 357.76 447.833 357.76 446.06C357.76 444.286 361.401 438.964 361.401 438.964C361.401 438.964 370.303 431.869 373.54 437.19Z",
    fill: "#FB8F8F"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M373.54 437.19C373.54 437.19 371.921 441.093 368.28 444.995C368.28 444.995 366.257 446.06 369.494 447.833C372.731 449.607 377.181 451.381 377.586 454.574C377.586 454.574 377.991 455.993 375.967 456.348C373.944 456.702 370.707 454.929 370.707 454.929C370.707 454.929 367.471 452.09 364.234 450.671C360.997 449.252 357.76 447.833 357.76 446.06C357.76 444.286 361.401 438.964 361.401 438.964C361.401 438.964 370.303 431.869 373.54 437.19Z",
    fill: "url(#paint2_radial_323_1929)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M373.54 437.19C373.54 437.19 371.921 441.093 368.28 444.995C368.28 444.995 366.257 446.06 369.494 447.833C372.731 449.607 377.181 451.381 377.586 454.574C377.586 454.574 377.991 455.993 375.967 456.348C373.944 456.702 370.707 454.929 370.707 454.929C370.707 454.929 367.471 452.09 364.234 450.671C360.997 449.252 357.76 447.833 357.76 446.06C357.76 444.286 361.401 438.964 361.401 438.964C361.401 438.964 370.303 431.869 373.54 437.19Z",
    fill: "#A9A9BF"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M393.945 422.163C388.162 422.607 382.342 421.921 376.822 420.306C370.533 418.464 359.047 416.029 348.485 418.701C339.615 420.941 334.502 425.619 328.939 429.363C323.134 433.266 315.864 434.996 308.648 434.278L303.99 433.815C303.563 433.773 303.31 434.233 303.609 434.511C305.017 435.809 309.336 438.069 321.74 436.218C338.507 433.716 344.095 427.282 344.095 427.282C344.095 427.282 344.494 433.716 342.498 436.933C340.503 440.15 334.915 445.511 334.915 445.511L339.305 455.877C339.305 455.877 342.099 456.949 346.09 455.877L347.288 454.805C347.288 454.805 347.687 451.945 344.893 451.588C344.893 451.588 342.897 450.873 344.095 447.656C345.292 444.439 347.288 443.367 356.068 443.367C364.849 443.367 368.844 438.005 368.844 438.005C368.844 438.005 376.427 438.363 381.619 442.294C386.808 446.226 401.179 450.873 409.561 448.371C409.561 448.371 413.153 451.588 413.552 454.09C413.951 456.592 414.35 458.021 418.741 457.664C418.741 457.664 421.934 457.307 421.135 455.162C420.337 453.017 418.342 455.162 417.543 452.303C416.745 449.443 416.346 446.226 416.346 446.226C416.346 446.226 421.934 444.439 421.135 435.861C420.337 427.282 424.328 422.632 429.916 423.347C435.504 424.062 441.091 424.777 441.091 424.777C441.091 424.777 445.881 426.207 451.069 422.99C456.258 419.773 457.056 417.986 457.056 417.986L456.657 416.198C456.657 416.198 443.083 411.552 441.487 410.48C439.89 409.407 434.303 404.761 434.303 404.761C434.303 404.761 419.133 404.761 415.541 407.978C411.948 411.194 406.76 419.058 401.568 420.848C399.611 421.522 396.843 421.943 393.945 422.163Z",
    fill: "#CACAEF"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M406.869 416.676C406.869 416.676 414.137 425.192 423.959 425.932L421.631 429.916C421.631 429.916 409.635 427.783 404.1 419.02L406.869 416.676Z",
    fill: "url(#paint3_radial_323_1929)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M356.449 443.538C360.55 443.538 363.609 442.385 365.705 441.149C364.616 440.486 363.445 439.923 362.178 439.493C358.68 438.299 354.761 438.109 351.049 437.92C347.665 437.749 344.427 437.882 341.436 439.095C338.977 442.126 335.254 445.659 335.254 445.659L339.651 455.923C339.651 455.923 342.45 456.984 346.448 455.923L347.647 454.861C347.647 454.861 348.047 452.029 345.248 451.676C345.248 451.676 343.249 450.968 344.449 447.782C345.648 444.597 347.654 443.538 356.449 443.538Z",
    fill: "#A9A9BF"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M417.631 452.459C417.377 451.567 417.165 450.643 416.993 449.794C415.207 449.676 413.429 450.104 412.043 451.102C412.812 452.072 413.514 453.194 413.676 454.195C414.072 456.624 414.467 458.013 418.813 457.666C418.813 457.666 421.974 457.319 421.184 455.236C420.401 453.153 418.421 455.236 417.631 452.459Z",
    fill: "#A9A9BF"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M431.838 409.644C431.728 410.22 431.435 410.746 431.046 411.201C430.054 412.355 427.919 415.773 428.822 423.182C429.979 432.706 419.566 433.439 418.023 427.212C416.904 422.691 417.41 416.627 417.771 413.641C417.913 412.486 418.643 411.479 419.724 410.936C423.605 408.983 432.747 404.839 431.838 409.644Z",
    fill: "#A394B7"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M436.836 410.056H437.558L440.086 410.762L441.169 412.528L439.002 414.646L436.836 415.352C434.669 412.881 436.836 410.056 436.836 410.056Z",
    fill: "url(#paint4_radial_323_1929)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M455.732 417.814L455.373 415.842C455.373 415.842 454.938 415.659 454.222 415.352C454.222 415.352 451.433 416.236 451.792 417.814C452.025 418.845 453.637 419.201 454.724 419.324C455.54 418.338 455.732 417.814 455.732 417.814Z",
    fill: "url(#paint5_radial_323_1929)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M437.197 414.028C437.93 414.028 438.521 413.435 438.521 412.704C438.521 411.973 437.93 411.38 437.197 411.38C436.464 411.38 435.873 411.973 435.873 412.704C435.873 413.435 436.464 414.028 437.197 414.028Z",
    fill: "url(#paint6_radial_323_1929)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M438.521 421.972C438.521 421.972 439.845 423.863 443.817 424.62",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M431.776 420.992C430.319 417.945 430.244 414.482 431.776 410.056C431.745 410.091 431.721 410.132 431.69 410.167C430.701 411.278 428.571 414.567 429.471 421.697C429.519 422.087 429.539 422.455 429.55 422.814C430.807 422.978 432.054 423.142 433.226 423.296C432.463 422.414 432.01 421.476 431.776 420.992Z",
    fill: "url(#paint7_radial_323_1929)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M409.394 449.051C407.382 446.852 407.382 445.387 407.382 445.387C408.589 440.99 407.382 439.525 407.382 439.525C407.382 443.188 405.37 445.02 405.37 445.02C405.37 445.02 395.312 448.684 387.262 440.99C379.215 433.296 378.41 432.563 378.41 432.563C372.777 432.563 368.352 438.426 368.352 438.426L368.79 438.458C370.478 438.605 376.74 439.364 381.23 442.822C386.457 446.852 400.945 451.615 409.394 449.051Z",
    fill: "#A9A9BF"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M448.45 420.648C449.334 420.648 449.334 419.324 448.45 419.324C447.572 419.324 447.566 420.648 448.45 420.648Z",
    fill: "#0061FE"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M446.723 422.451C447.066 422.451 447.066 421.972 446.723 421.972C446.379 421.972 446.379 422.451 446.723 422.451Z",
    fill: "#0061FE"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M445.969 420.845C446.313 420.845 446.313 420.365 445.969 420.365C445.629 420.365 445.626 420.845 445.969 420.845Z",
    fill: "#0061FE"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M443.163 420.633C443.334 420.633 443.334 420.391 443.163 420.391C442.987 420.391 442.987 420.633 443.163 420.633Z",
    fill: "#0061FE"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M449.084 421.722C449.255 421.722 449.255 421.479 449.084 421.479C448.912 421.479 448.912 421.722 449.084 421.722Z",
    fill: "#0061FE"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M403.395 418.538C404.272 418.538 404.985 417.898 404.985 417.107C404.985 416.317 404.272 415.677 403.395 415.677C402.518 415.677 401.805 416.317 401.805 417.107C401.805 417.898 402.518 418.538 403.395 418.538Z",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M404.691 417.944L405.244 418.404",
    stroke: "#0144B9",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M407.311 424.732C407.311 424.732 411.926 429.526 418.316 430.165",
    stroke: "#0061FE",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M428.97 422.181C428.97 422.181 429.325 426.656 426.842 428.254",
    stroke: "#F1D23C",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M355.129 442.31C355.129 442.31 363.649 442.31 367.199 437.837",
    stroke: "#F1D23C",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M383.529 442.312C383.529 442.312 389.919 446.787 397.73 447.426",
    stroke: "#EECFF8",
    strokeWidth: 0.385417,
    strokeMiterlimit: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_323_1929)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M353.037 188.789H244.304C243.452 188.788 242.635 188.449 242.034 187.848C241.432 187.247 241.094 186.432 241.094 185.583V33.1831C241.101 32.3386 241.442 31.5312 242.043 30.9362C242.644 30.3411 243.457 30.0066 244.304 30.0051H353.037C353.89 30.0051 354.708 30.3429 355.311 30.9441C355.914 31.5454 356.253 32.3608 356.253 33.2111V33.2111V185.583C356.253 186.433 355.914 187.249 355.311 187.85C354.708 188.451 353.89 188.789 353.037 188.789V188.789ZM244.304 30.1174C243.489 30.1189 242.708 30.4425 242.133 31.0173C241.558 31.5921 241.235 32.371 241.235 33.1831V185.583C241.235 186.395 241.558 187.174 242.133 187.749C242.708 188.324 243.489 188.647 244.304 188.649H353.037C353.852 188.646 354.632 188.322 355.208 187.748C355.784 187.173 356.109 186.395 356.112 185.583V33.1831C356.109 32.3709 355.784 31.5929 355.208 31.0186C354.632 30.4443 353.852 30.1204 353.037 30.1174H244.304Z",
    fill: "#EBEBEB"
  }))), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M200.183 172.655C203.633 163.275 205.711 159.375 205.711 159.375L203.117 148.183L194.052 137.887L178.472 142.58L178.55 143.656C178.55 143.656 182.519 157.469 178.243 163.656C173.968 169.843 168.595 177.173 163.258 176.94C157.921 176.707 162.08 177.008 162.08 177.008L177.156 197.202L197.012 193.899L204.779 186.972C204.779 186.972 196.733 182.034 200.183 172.655Z",
    fill: "#FFB7B7"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M229.407 126.493C229.407 126.493 227.086 166.062 217.629 171.605C217.629 171.605 188.996 168.809 192.948 143.587C196.901 118.366 229.407 126.493 229.407 126.493Z",
    fill: "#FFB7B7"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M190.126 143.483C190.126 143.483 185.998 160.578 190.404 163.587C190.404 163.587 194.85 167.138 197.827 166.967C197.827 166.967 204.099 170.956 209.418 170.106C209.418 170.106 213.785 172.574 216.682 171.319C216.682 171.319 220.255 171.114 221.843 168.303C223.431 165.493 226.432 154.64 226.432 154.64C226.432 154.64 206.917 152.305 205.449 148.583C203.98 144.861 204.178 139.411 204.178 139.411L196.888 132.87L205.17 128.478C205.17 128.478 209.696 133.112 216.761 131.618C216.761 131.618 223.39 132.324 226.685 128.328C226.685 128.328 232.203 130.185 237.165 124.462C242.126 118.738 241.253 114.982 241.253 114.982C241.253 114.982 249.589 114.502 248.636 109.663C247.684 104.824 241.848 98.6341 233.592 100.197C225.335 101.76 215.928 103.932 215.928 103.932C214.697 103.459 209.219 102.143 209.219 102.143C209.219 102.143 208.505 100.553 206.718 100.656C204.932 100.759 197.311 102.829 193.619 101.41C189.927 99.9908 181.552 99.9291 179.329 102.232C177.106 104.535 175.359 113.336 175.359 113.336C175.359 113.336 164.959 118.285 167.897 125.729C170.834 133.173 171.906 131.48 172.263 136.354C172.621 141.228 169.207 143.599 172.899 145.018C176.59 146.437 182.028 147.212 182.028 147.212L190.126 143.483Z",
    fill: "#190D03"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.557 136.088C222.364 136.031 222.166 136.132 222.115 136.314L220.797 140.981C220.783 141.031 220.781 141.083 220.791 141.135L220.812 141.236L220.869 141.524C220.918 141.773 220.988 142.13 221.072 142.565C221.24 143.435 221.464 144.612 221.686 145.845C221.908 147.078 222.128 148.364 222.29 149.45C222.453 150.549 222.55 151.412 222.539 151.819C222.53 152.147 222.365 152.452 222.054 152.725C221.741 152.999 221.293 153.227 220.768 153.388C219.709 153.711 218.43 153.735 217.51 153.419C217.32 153.354 217.117 153.446 217.057 153.626C216.997 153.805 217.103 154.003 217.293 154.068C218.397 154.447 219.842 154.405 221.015 154.047C221.604 153.866 222.149 153.599 222.555 153.243C222.963 152.885 223.245 152.424 223.261 151.868C223.274 151.391 223.166 150.467 223.005 149.383C222.842 148.286 222.62 146.993 222.398 145.757C222.175 144.521 221.951 143.34 221.782 142.469C221.698 142.033 221.627 141.675 221.578 141.425L221.521 141.136L221.516 141.113L222.813 136.521C222.864 136.339 222.75 136.145 222.557 136.088Z",
    fill: "#3E1A0B"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.418 154.583C207.241 154.665 207.172 154.858 207.265 155.013C208.528 157.118 209.998 158.459 211.507 159.275C213.017 160.091 214.547 160.371 215.912 160.381C217.273 160.391 218.469 160.133 219.323 159.874C219.751 159.745 220.095 159.614 220.333 159.515C220.452 159.466 220.545 159.424 220.609 159.395C220.641 159.38 220.666 159.368 220.684 159.359L220.704 159.349L220.71 159.347L220.712 159.346L220.712 159.345C220.712 159.345 220.713 159.345 220.533 159.07L220.713 159.345C220.886 159.257 220.947 159.062 220.847 158.91C220.748 158.758 220.527 158.707 220.353 158.794L220.353 158.794C220.353 158.794 220.353 158.794 220.353 158.795L220.353 158.795L220.35 158.796L220.336 158.803C220.322 158.809 220.302 158.819 220.274 158.832C220.219 158.858 220.135 158.895 220.026 158.94C219.808 159.031 219.489 159.152 219.09 159.273C218.29 159.515 217.178 159.754 215.922 159.745C214.669 159.735 213.272 159.479 211.89 158.733C210.508 157.986 209.121 156.737 207.907 154.714C207.814 154.559 207.595 154.5 207.418 154.583Z",
    fill: "#926D5E"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M224.139 134.27C224.139 134.27 227.268 133.862 228.77 135.887Z",
    fill: "#3E1A0B"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M205.537 137.538C206.748 136.392 208.257 135.642 209.911 135.363C211.565 135.085 213.307 135.288 214.963 135.953C215.162 136.033 215.367 135.93 215.42 135.724C215.473 135.518 215.355 135.286 215.155 135.206C213.373 134.491 211.498 134.272 209.717 134.572C207.936 134.871 206.312 135.679 205.008 136.913C204.862 137.051 204.862 137.303 205.008 137.476C205.154 137.648 205.391 137.676 205.537 137.538Z",
    fill: "#3E1A0B"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M210.135 142.186C210.179 143.282 210.74 144.187 211.483 144.175C212.226 144.162 212.721 143.28 212.673 142.171C212.625 141.063 212.068 140.17 211.325 140.183C210.582 140.195 210.035 141.049 210.135 142.186Z",
    fill: "#3E1A0B"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M224.698 142.186C224.742 143.282 225.303 144.187 226.046 144.175C226.789 144.162 227.283 143.28 227.239 142.184C227.195 141.087 226.63 140.17 225.887 140.182C225.144 140.194 224.649 141.077 224.698 142.186Z",
    fill: "#3E1A0B"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M228.015 512C198.767 512 175.057 509.629 175.057 506.704C175.057 503.779 198.767 501.408 228.015 501.408C257.263 501.408 280.973 503.779 280.973 506.704C280.973 509.629 257.263 512 228.015 512Z",
    fill: "url(#paint8_linear_323_1929)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M429.916 452.423C425.163 452.423 421.31 451.83 421.31 451.099C421.31 450.367 425.163 449.775 429.916 449.775C434.669 449.775 438.521 450.367 438.521 451.099C438.521 451.83 434.669 452.423 429.916 452.423Z",
    fill: "url(#paint9_linear_323_1929)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M414.029 457.718C409.276 457.718 405.423 457.126 405.423 456.394C405.423 455.663 409.276 455.07 414.029 455.07C418.782 455.07 422.635 455.663 422.635 456.394C422.635 457.126 418.782 457.718 414.029 457.718Z",
    fill: "url(#paint10_linear_323_1929)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M367.691 456.394C362.938 456.394 359.086 455.802 359.086 455.07C359.086 454.339 362.938 453.746 367.691 453.746C372.444 453.746 376.297 454.339 376.297 455.07C376.297 455.802 372.444 456.394 367.691 456.394Z",
    fill: "url(#paint11_linear_323_1929)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M338.564 456.394C333.812 456.394 329.959 455.802 329.959 455.07C329.959 454.339 333.812 453.746 338.564 453.746C343.317 453.746 347.17 454.339 347.17 455.07C347.17 455.802 343.317 456.394 338.564 456.394Z",
    fill: "url(#paint12_linear_323_1929)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M137.324 505.38C110.636 505.38 89.0005 503.009 89.0005 500.084C89.0005 497.16 110.636 494.789 137.324 494.789C164.013 494.789 185.648 497.16 185.648 500.084C185.648 503.009 164.013 505.38 137.324 505.38Z",
    fill: "url(#paint13_linear_323_1929)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M159.019 477.168C159.019 477.168 167.254 487.818 169.858 489.72C172.462 491.623 183.286 495.799 183.722 497.382C184.159 498.965 185.017 500.038 183.286 501.213C181.554 502.388 160.751 502.732 156.852 502.732C152.953 502.732 150.349 499.31 148.617 498.161C146.886 497.012 141.678 493.602 138.652 491.7C135.626 489.797 126.519 485.225 126.082 482.569C125.646 479.913 137.721 469.634 137.721 469.634L159.019 477.168Z",
    fill: "#EDB841"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M183.283 501.21C181.552 502.349 160.749 502.732 156.85 502.732C152.952 502.732 150.348 499.305 148.617 498.154C146.885 497.003 141.677 493.589 138.652 491.683C135.626 489.778 126.519 485.199 126.083 482.539C125.923 481.58 127.377 479.662 129.298 477.577C132.555 480.268 135.539 483.203 138.215 486.35C142.114 491.299 152.952 497.4 159.018 497.77C165.084 498.141 183.749 497.4 183.749 497.4C184.156 498.921 185.014 500.06 183.283 501.21Z",
    fill: "#00121F",
    stroke: "#00121F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M193.345 312.597C192.961 312.589 192.657 312.586 192.442 312.585L181.388 352.306L170.246 398.148L170.213 398.286L170.112 398.386C166.426 402.024 163.002 405.869 159.862 409.898C157.551 412.918 155.643 417.189 153.988 421.988C152.334 426.781 150.946 432.059 149.657 437.072C148.362 442.107 145.89 449.542 143.747 455.706C142.674 458.791 141.683 461.562 140.959 463.562C140.597 464.562 140.302 465.369 140.098 465.926C140.037 466.091 139.985 466.233 139.941 466.353L160.576 475.609C160.616 475.537 160.662 475.455 160.712 475.364C160.943 474.946 161.277 474.337 161.692 473.576C162.523 472.054 163.674 469.925 164.96 467.495C167.532 462.632 170.636 456.575 172.774 451.773C174.935 446.919 179.888 438.506 184.926 430.37C189.97 422.223 195.12 414.318 197.693 410.466C200.23 406.668 204.282 397.665 208.415 387.681C212.538 377.718 216.718 366.837 219.51 359.326C222.301 351.816 225.302 343.345 227.605 336.75C228.757 333.453 229.734 330.625 230.423 328.622C230.767 327.62 231.04 326.825 231.226 326.28C231.312 326.029 231.38 325.831 231.428 325.69C226.357 319.056 216.662 315.755 208.071 314.13C203.75 313.313 199.746 312.927 196.822 312.745C195.36 312.654 194.169 312.614 193.345 312.597Z",
    fill: "#145079",
    stroke: "#104467"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M165.525 473.47C165.525 473.47 162.551 478.587 161.693 480.156C160.835 481.725 152.329 482.121 148.497 480.552C144.666 478.982 134.014 473.866 134.014 471.505C134.014 469.145 137.417 463.264 138.704 461.299C139.99 459.334 144.666 460.903 147.639 462.09C150.613 463.277 161.693 468.367 162.98 468.763C163.497 468.896 163.979 469.128 164.393 469.444C164.807 469.76 165.145 470.152 165.385 470.596C165.625 471.039 165.761 471.524 165.785 472.019C165.809 472.514 165.721 473.009 165.525 473.47V473.47Z",
    fill: "white"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M165.525 473.47C165.525 473.47 162.551 478.587 161.693 480.156C160.835 481.725 152.329 482.121 148.497 480.552C144.666 478.982 134.014 473.866 134.014 471.505C134.014 469.145 137.417 463.264 138.704 461.299C139.99 459.334 144.666 460.903 147.639 462.09C150.613 463.277 161.693 468.367 162.98 468.763C163.497 468.896 163.979 469.128 164.393 469.444C164.807 469.76 165.145 470.152 165.385 470.596C165.625 471.039 165.761 471.524 165.785 472.019C165.809 472.514 165.721 473.009 165.525 473.47V473.47Z",
    fill: "#145079"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M242.206 484.197C244.842 486.704 247.778 488.938 250.961 490.858C256.623 494.399 270.091 497.927 274.877 498.756C279.663 499.586 279.648 501.903 279.648 504.246C279.648 506.589 263.131 510.13 254.843 511.315C246.555 512.5 224.419 512.091 222.245 510.525C220.071 508.958 220.071 493.267 220.071 491.701C220.071 490.134 242.206 484.197 242.206 484.197Z",
    fill: "#EDB841"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M222.839 510.588C222.131 510.109 221.669 508.213 221.395 505.838C229.272 506.876 237.233 507.378 245.203 507.34C256.778 507.37 268.234 505.35 278.844 501.408C279.489 502.438 279.755 503.608 279.61 504.768C279.61 506.971 263.266 510.269 255.065 511.376C246.864 512.484 224.99 512.053 222.839 510.588Z",
    fill: "#00121F",
    stroke: "#00121F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M164.802 334.459C165.242 334.223 165.242 334.223 165.242 334.223L165.242 334.223L165.243 334.224L165.246 334.229L165.257 334.25L165.301 334.331C165.339 334.402 165.396 334.508 165.469 334.643C165.615 334.914 165.827 335.305 166.09 335.786C166.615 336.748 167.342 338.071 168.15 339.513C169.769 342.402 171.701 345.745 172.985 347.626C173.332 348.135 173.935 349.269 174.714 350.828C175.5 352.399 176.48 354.437 177.588 356.78C179.804 361.466 182.532 367.384 185.232 373.265C185.958 374.847 186.682 376.427 187.394 377.979C189.329 382.197 191.17 386.213 192.709 389.533C193.762 391.804 194.671 393.748 195.372 395.206C196.08 396.682 196.556 397.625 196.751 397.927C197.018 398.342 197.202 398.925 197.339 399.6C197.479 400.285 197.579 401.113 197.653 402.049C197.801 403.921 197.847 406.277 197.878 408.891C197.884 409.441 197.89 410.003 197.896 410.575C197.946 415.452 198.004 421.045 198.553 426.178C199.604 436.011 203.224 443.281 207.813 452.499C208.553 453.984 209.318 455.521 210.102 457.127C212.921 462.904 215.516 468.966 217.407 473.581C218.352 475.889 219.121 477.837 219.655 479.207C219.921 479.893 220.129 480.434 220.27 480.804C220.305 480.897 220.336 480.979 220.363 481.049H223.926L223.966 481.041L224.221 480.991C224.442 480.947 224.764 480.883 225.165 480.803C225.967 480.643 227.085 480.416 228.352 480.154C230.888 479.629 234.012 478.96 236.381 478.381C238.743 477.805 239.879 477.338 240.414 477.036C240.558 476.955 240.651 476.889 240.71 476.842C240.672 476.697 240.617 476.486 240.547 476.216C240.406 475.666 240.203 474.874 239.96 473.903C239.474 471.961 238.827 469.303 238.179 466.441C236.889 460.742 235.579 454.151 235.579 450.821C235.579 449.227 235.206 445.635 234.638 441.006C234.072 436.392 233.316 430.786 232.561 425.189L232.486 424.638C231.756 419.228 231.031 413.857 230.482 409.437C229.917 404.884 229.534 401.298 229.534 399.732C229.534 396.848 228.95 392.548 228.235 387.287C228.203 387.051 228.17 386.813 228.138 386.573C227.382 381.005 226.514 374.458 226.07 367.527C225.629 360.629 224.543 350.075 223.566 341.238C223.078 336.822 222.618 332.837 222.279 329.956C222.11 328.516 221.971 327.352 221.875 326.547C221.826 326.145 221.789 325.833 221.763 325.622L221.742 325.45C221.696 325.396 221.634 325.325 221.557 325.236C221.372 325.025 221.101 324.718 220.76 324.341C220.078 323.585 219.115 322.546 217.991 321.41C215.734 319.128 212.86 316.491 210.322 314.965C207.789 313.442 202.773 311.522 196.855 309.982C190.946 308.444 184.192 307.3 178.196 307.3C177.441 307.3 176.71 307.297 176.002 307.294C173.86 307.285 171.932 307.278 170.203 307.354C167.903 307.457 166.011 307.707 164.494 308.28C162.996 308.846 161.867 309.725 161.076 311.106C160.276 312.504 159.798 314.455 159.691 317.199C159.478 322.673 160.855 326.91 162.281 329.775C162.994 331.208 163.72 332.298 164.264 333.027C164.537 333.391 164.763 333.665 164.92 333.846C164.999 333.936 165.06 334.004 165.101 334.047C165.121 334.069 165.136 334.085 165.146 334.096L165.156 334.106L165.158 334.108L165.158 334.108L165.158 334.108L165.158 334.108L165.208 334.159L165.242 334.223L164.802 334.459Z",
    fill: "#145079",
    stroke: "#104467"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M243.669 473.606C243.669 473.606 230.354 477.885 226.907 479.046C223.459 480.207 217.458 480.207 217.458 482.543C217.458 484.878 217.025 493.045 219.174 493.424C221.324 493.802 233.788 491.48 238.086 489.927C242.385 488.375 245.386 488.375 246.251 486.822C247.117 485.269 245.819 480.99 245.819 478.655C245.586 476.834 244.846 475.097 243.669 473.606Z",
    fill: "white"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M243.669 473.606C243.669 473.606 230.354 477.885 226.907 479.046C223.459 480.207 217.458 480.207 217.458 482.543C217.458 484.878 217.025 493.045 219.174 493.424C221.324 493.802 233.788 491.48 238.086 489.927C242.385 488.375 245.386 488.375 246.251 486.822C247.117 485.269 245.819 480.99 245.819 478.655C245.586 476.834 244.846 475.097 243.669 473.606Z",
    fill: "#145079"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M203.379 173.529C203.379 173.529 225.177 178.161 227.183 180.187C229.188 182.212 242.515 202.779 243.489 203.643C245.735 205.444 248.135 207.087 250.668 208.559C252.307 209.674 253.553 211.183 254.257 212.907C254.577 214.068 255.551 215.797 259.474 221.938C263.398 228.08 272.554 238.441 269.909 239.021C267.264 239.602 258.82 237.279 251.641 235.834C244.462 234.389 235.336 227.719 235.336 227.719C235.336 227.719 236.949 245.085 236.949 255.51C236.949 265.935 236.629 300.668 236.629 307.042C236.629 313.416 237.283 319.79 236.629 321.815C235.975 323.841 231.412 330.202 231.412 330.202L227.822 326.447L224.916 331.944C224.916 331.944 221.007 327.596 204.701 322.68C188.395 317.764 181.216 315.725 176.973 316.022C172.729 316.319 149.579 327.892 148.271 328.473C146.963 329.053 149.579 306.462 149.579 293.727C149.579 280.992 150.553 258.4 150.553 258.4C150.553 258.4 139.464 210.662 138.171 200.211C136.877 189.76 142.734 180.225 145.016 177.335C147.297 174.445 175.011 167.775 175.011 167.775L203.379 173.529Z",
    fill: "#EFB741"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M235.959 227.352C235.959 227.352 235.111 212.598 231.987 203.521",
    stroke: "#D29636",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M254.494 215.437C254.494 215.437 251.97 226.465 252.323 229.856C252.677 233.246 250.522 230.713 250.522 222.785",
    stroke: "#D29636",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M200.212 183.662C200.212 183.662 209.148 209.301 212.127 222.056",
    stroke: "#D29636",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M224.043 264.422L225.367 278.986",
    stroke: "#0044B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M225.366 289.577C225.366 289.577 228.721 313.21 227.878 324",
    stroke: "#0044B2",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 211.746C261.723 215.815 263.79 219.628 266.586 222.974C271.4 228.884 273.215 229.766 276.101 230.069C278.987 230.372 282.616 225.936 283.587 224.159C284.559 222.382 285.501 224.159 284.544 230.069C283.587 235.979 275.244 241.915 270.758 241.915C266.271 241.915 259.214 233.649 257.614 229.516C256.029 225.346 255.482 220.902 256.014 216.511C256.656 213.234 256.657 210.575 260.5 211.746Z",
    fill: "url(#paint14_radial_323_1929)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M260.5 211.746C261.723 215.815 263.79 219.628 266.586 222.974C271.4 228.884 273.215 229.766 276.101 230.069C278.987 230.372 282.616 225.936 283.587 224.159C284.559 222.382 285.501 224.159 284.544 230.069C283.587 235.979 275.244 241.915 270.758 241.915C266.271 241.915 259.214 233.649 257.614 229.516C256.029 225.346 255.482 220.902 256.014 216.511C256.656 213.234 256.657 210.575 260.5 211.746Z",
    fill: "#D29636"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M253.713 166.696C253.713 166.696 247.121 161.16 245.8 159.708C244.478 158.256 243.157 151.567 242.863 149.531C242.57 147.496 238.635 142.142 238.606 141.182C238.577 140.223 240.881 139.341 242.54 141.091C243.786 142.657 244.886 144.309 245.829 146.031C246.49 146.912 248.457 146.614 248.457 146.614C248.457 146.614 248.252 145.059 247.914 143.321C247.576 141.584 243.935 136.683 242.614 134.933C241.293 133.183 242.438 128.451 245.447 131.977C248.457 135.504 254.388 141.96 254.388 141.96C254.388 141.96 263.946 152.435 265.267 155.054C266.589 157.673 266.589 162.042 266.589 164.661C266.589 167.28 265.59 166.113 267.249 170.767C268.908 175.421 278.114 195.49 282.063 204.228C286.012 212.966 287.334 219.345 285.366 222.845C283.399 226.345 277.453 231.92 274.164 231.272C270.876 230.624 262.625 220.81 260.951 217.309C259.673 214.243 259.113 210.979 259.307 207.716C259.307 205.123 260.951 188.269 259.307 182.111C257.662 175.953 253.713 166.696 253.713 166.696Z",
    fill: "#FFB7B7"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M263.819 157.106L262.192 156.018C261.389 156.85 260.447 157.562 259.403 158.128C258.499 158.424 257.519 158.467 256.589 158.249C255.659 158.031 254.823 157.564 254.187 156.907L253.707 156.204L251.107 153.551L248.666 151.11C248.388 150.827 248.174 150.495 248.04 150.135C247.905 149.775 247.851 149.393 247.882 149.014C247.931 147.733 248.342 146.486 249.073 145.392C249.785 144.53 252.4 138.971 254.042 138.666C255.683 138.361 257.616 141.943 257.616 141.943C259.228 142.801 260.664 143.91 261.858 145.22C262.384 145.972 262.822 146.772 263.165 147.608C263.165 147.608 267.408 149.69 267.727 152.37C267.77 155.75 267.546 159.128 267.059 162.479",
    fill: "#FFB7B7"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M257.141 142.62C257.141 142.62 251.002 149.439 250.521 151.887Z",
    fill: "#3E1A0B"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M262.438 147.915C262.438 147.915 255.346 151.597 253.17 155.859Z",
    fill: "#3E1A0B"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M197.564 170.422L203.283 173.432L205.508 184.986L202.97 182.98L197.893 172.936L197.564 170.422Z",
    fill: "url(#paint15_radial_323_1929)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M197.564 170.422L203.283 173.432L205.508 184.986L202.97 182.98L197.893 172.936L197.564 170.422Z",
    fill: "#D29636"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M178.738 158.507L200.211 177.76L195.22 184.986L173.732 167.606L178.738 158.507Z",
    fill: "url(#paint16_radial_323_1929)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M178.738 158.507L200.211 177.76L195.22 184.986L173.732 167.606L178.738 158.507Z",
    fill: "#D29636"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M316.719 223.266L300.735 245.582L288.916 245.887L304.21 222.056L316.719 223.266Z",
    fill: "white"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M316.719 223.266L300.735 245.582L288.916 245.887L304.21 222.056L316.719 223.266Z",
    fill: "url(#paint17_radial_323_1929)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M201.599 238.281C201.599 238.281 240.953 245.657 251.9 245.955C262.846 246.254 270.385 246.578 270.385 246.578C270.385 246.578 275.873 241.042 279.628 237.658C283.383 234.275 290.589 235.519 290.589 235.519C290.589 235.519 299.138 235.817 301.536 235.817C303.933 235.817 310.1 237.36 310.1 238.579C310.1 239.797 308.728 240.433 306.677 240.433H299.832L295.037 241.664C298.267 242.102 301.465 242.717 304.612 243.505C305.984 244.115 304.612 246.876 304.612 246.876L303.254 248.107L301.81 250.571L300.092 251.802C300.092 251.802 300.092 253.332 296.669 254.564C293.246 255.795 281.274 256.405 279.209 256.405H273.735C273.735 256.405 241.964 259.788 234.743 260.709C227.522 261.629 201.527 262.238 195.75 261.318C189.974 260.398 187.187 261.02 185.815 258.868C184.443 256.716 191.981 242.274 194.032 240.122C196.083 237.969 201.599 238.281 201.599 238.281Z",
    fill: "#FFB7B7"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M171.577 189.291C171.577 189.291 180.112 205.573 182.502 212.322C184.891 219.071 186.244 220.923 185.568 223.371C185.36 224.061 185.345 224.785 185.523 225.481C185.701 226.177 186.067 226.823 186.589 227.361C186.589 227.361 189.324 229.822 189.324 230.742C189.324 231.661 192.735 231.053 189.655 236.882C186.575 242.711 180.789 254.071 179.091 256.532C178.269 257.747 176.949 258.622 175.416 258.966C173.882 259.31 172.26 259.097 170.901 258.371C167.835 256.843 159.645 253.19 158.623 247.931C157.601 242.672 157.601 237.49 156.234 235.353C154.867 233.216 144.978 216.921 142.244 208.022C139.509 199.123 138.156 193.592 140.545 187.763C142.934 181.934 147.368 181.014 147.368 181.014",
    fill: "url(#paint18_linear_323_1929)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M188.117 231.324C188.117 231.324 172.743 251.396 171.696 254.091C170.65 256.786 170.989 258.647 172.389 259.866C173.789 261.086 183.916 264.422 186.716 264.422C189.517 264.422 190.564 260.47 190.564 258.647C190.564 256.825 204.183 238.267 204.183 238.267C203.589 236.758 202.766 235.326 201.737 234.006C200.69 233.146 188.117 231.324 188.117 231.324Z",
    fill: "url(#paint19_radial_323_1929)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M188.117 231.324C188.117 231.324 172.743 251.396 171.696 254.091C170.65 256.786 170.989 258.647 172.389 259.866C173.789 261.086 183.916 264.422 186.716 264.422C189.517 264.422 190.564 260.47 190.564 258.647C190.564 256.825 204.183 238.267 204.183 238.267C203.589 236.758 202.766 235.326 201.737 234.006C200.69 233.146 188.117 231.324 188.117 231.324Z",
    fill: "#D29636"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M171.084 241.915C169.94 242.952 169.03 244.317 168.436 245.887",
    stroke: "#D29636",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M185.648 232.648C185.648 232.648 179.035 235.946 173.733 239.268",
    stroke: "#D29636",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M183 231.324C183 231.324 169.794 232.913 168.437 235.296",
    stroke: "#D29636",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M303.479 248.535C303.479 248.535 295.735 247.349 290.631 249.416Z",
    fill: "#3E1A0B"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M300.832 252.507C300.832 252.507 290.565 250.921 287.816 251.798Z",
    fill: "#3E1A0B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_323_1929",
    x1: 258.924,
    y1: -205.286,
    x2: 315,
    y2: 704.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF5DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(439.468 462.497) scale(46.217 40.9592)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(371.043 473.487) scale(51.8092 45.4257)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(414.817 408.716) scale(28.0029 25.3342)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3231,
    stopColor: "#C184A8",
    stopOpacity: 0.2102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9171,
    stopColor: "#0061FE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(435.027 412.48) scale(6.04347 5.90917)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0144B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0286,
    stopColor: "#0C47B7",
    stopOpacity: 0.9606
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2403,
    stopColor: "#5C5FAA",
    stopOpacity: 0.6686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#8E6EA1",
    stopOpacity: 0.4611
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4648,
    stopColor: "#A1749E",
    stopOpacity: 0.3591
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#A7769D",
    stopOpacity: 0.3443
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6368,
    stopColor: "#CB8197",
    stopOpacity: 0.2437
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7768,
    stopColor: "#E68993",
    stopOpacity: 0.1497
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9021,
    stopColor: "#F58D90",
    stopOpacity: 0.0657
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(461.824 432.438) scale(18.3244 20.1752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3846,
    stopColor: "#F58D90",
    stopOpacity: 0.0982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#E58993",
    stopOpacity: 0.2238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#CB8197",
    stopOpacity: 0.3644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#A6769D",
    stopOpacity: 0.5158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7768A5",
    stopOpacity: 0.6762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#3F57AF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(436.374 419.55) scale(11.7596 7.34984)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3846,
    stopColor: "#F58D90",
    stopOpacity: 0.0982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#E58993",
    stopOpacity: 0.2238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#CB8197",
    stopOpacity: 0.3644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#A6769D",
    stopOpacity: 0.5158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7768A5",
    stopOpacity: 0.6762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#3F57AF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(433.607 416.8) rotate(103.156) scale(9.66024 5.52292)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3176,
    stopColor: "#FB8F8F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3846,
    stopColor: "#F58D90",
    stopOpacity: 0.0982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4703,
    stopColor: "#E58993",
    stopOpacity: 0.2238
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5662,
    stopColor: "#CB8197",
    stopOpacity: 0.3644
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6696,
    stopColor: "#A6769D",
    stopOpacity: 0.5158
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.779,
    stopColor: "#7768A5",
    stopOpacity: 0.6762
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8915,
    stopColor: "#3F57AF",
    stopOpacity: 0.8411
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0144B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_323_1929",
    x1: 268.684,
    y1: 504.056,
    x2: 177.302,
    y2: 490.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_323_1929",
    x1: 432.388,
    y1: 449.775,
    x2: 421.825,
    y2: 451.466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D456D",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_323_1929",
    x1: 416.501,
    y1: 455.07,
    x2: 405.938,
    y2: 456.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D456D",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_323_1929",
    x1: 370.163,
    y1: 453.746,
    x2: 359.6,
    y2: 455.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D456D",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_323_1929",
    x1: 341.036,
    y1: 453.746,
    x2: 330.474,
    y2: 455.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D456D",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_323_1929",
    x1: 174.435,
    y1: 497.437,
    x2: 90.7516,
    y2: 486.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DBCAA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBFBFB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.556 226.539) rotate(-148.922) scale(55.6062 80.1935)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(205.268 163.904) rotate(180) scale(19.6729 47.4993)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(199.412 146.655) rotate(180) scale(65.5762 86.3624)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(291.293 241.257) rotate(179.406) scale(43.959 22.643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2B1F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1471,
    stopColor: "#B0B0F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EECFF8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_323_1929",
    x1: 181.087,
    y1: 206.599,
    x2: 156.204,
    y2: 238.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9A12B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB741"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_323_1929",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(203.185 216.509) rotate(180) scale(81.9703 107.953)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0061FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_323_1929"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.23,
    height: 104.029,
    fill: "white",
    transform: "translate(211.836 49)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntro1);
export default __webpack_public_path__ + "static/media/intro_1.87b4fa3497eb6e8495fb4e674ca616a1.svg";
export { ForwardRef as ReactComponent };